import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';

const Diagnostics = ({ className, size = 'xs', types }) => {
	const { t } = useTranslation('component_diagnostics');

	const typesDataMap = {
		blood_sample: {
			label: t('t1'),
			textColor: 'text-danger',
		},
		mri: {
			label: t('t2'),
			textColor: 'text-blue-600',
		},
	};

	const sizes = {
		md: 'lead',
		sm: 'sm',
		xs: 'xs',
	};

	if (!Array.isArray(types) || types.length === 0) return null;

	return (
		<div className={`diagnostics d-flex flex-wrap gap-2 ${className}`}>
			{types.map((typeObj, index) => {
				const typeKey = typeObj.type;
				const data = typesDataMap[typeKey] || {
					label: typeKey,
					textColor: 'text-secondary',
				};

				return (
					<span className={`${sizes[size]} ${data.textColor}`} key={index}>
						{data.label}
					</span>
				);
			})}
		</div>
	);
};

Diagnostics.propTypes = {
	className: PropTypes.string,
	size: PropTypes.oneOf(['xs', 'sm', 'md']),
	types: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
		}),
	),
};

export default Diagnostics;
